export default function timeseriesToFilmstripTransformer(data, maxFrames) {
    //Number of frames to aim for.
    let frameTarget = 10;
    if (maxFrames) {
        frameTarget = maxFrames;
    }
    // find the latest test id in each series and build a request url for WPT thumbnails
    let tests = "";
    let names = "";
    let colors = "";
    let interval = 500; // in milliseconds
    let maxTime = 0; //used to work out the time interval, so we have a good number of frames
    data.forEach((series) => {
        const test = series.data[series.data.length - 1].test;
        if (typeof test === "undefined") {
            return false;
        }
        const test_run = series.data[series.data.length - 1].test_run;
        // 220905_MD_3118ea569a37749f4d2ad469630cb1c9-r:2-l:Smashing,
        if (test_run) {
            tests += test + "-r:" + test_run + ",";
        }
        else {
            tests += test + ",";
        }
        names += encodeURIComponent(series.name) + ";";
        colors += encodeURIComponent(series.color) + ";";
        if (series.data[series.data.length - 1].y !== null && Number(series.data[series.data.length - 1].y) > maxTime) {
            maxTime = Number(series.data[series.data.length - 1].y);
        }
    });
    const timePerFrame = maxTime / frameTarget; // number of frames to aim for
    if (timePerFrame < 0.1) {
        interval = 100;
    }
    else if (timePerFrame < 0.2) {
        interval = 200;
    }
    else if (timePerFrame < 0.5) {
        interval = 500;
    }
    else if (timePerFrame < 1) {
        interval = 1000;
    }
    else if (timePerFrame < 2) {
        interval = 2000;
    }
    else if (timePerFrame < 5) {
        interval = 5000;
    }
    else if (timePerFrame > 5) {
        interval = 10000;
    }
    // Todo: the WPT host should be pulled from env vars
    return ("https://wpt.speedcurve.com/video/filmstrip-speedcurve.php?tests=" +
        tests +
        "&sitename=" +
        names +
        "&sitecolor=" +
        colors +
        "&end=visual&format=json&ival=" +
        interval +
        "&thumbSize=150");
}
